import { post, get } from "../network/index.js";
// 页面列表
const pageList = (data) => {
    return post("/mercWebi/wxPageManage/list", data);
};
// 新建页面
const addPage = (data) => {
    return post("/mercWebi/wxPageManage/add", data);
};
// 编辑页面
const updatePage = (data) => {
    return post("/mercWebi/wxPageManage/update", data);
};
// 页面详情
const pageDetail = (data) => {
    return post("/mercWebi/wxPageManage/detail", data);
};
// 删除页面
const deletePage = (data) => {
    return post("/mercWebi/wxPageManage/delete", data);
};
// 查询商家团购列表信息
const queryGroup = (data) => {
    return post("/mercWebi/webGroupInfo/listGroupInfo", data);
};
// 系统内选择链接
const selectList = (data) => {
    return post("/mercWebi/wxPageManage/selectList", data);
};
export default {
    pageList,
    addPage,
    updatePage,
    pageDetail,
    deletePage,
    queryGroup,
    selectList
};